'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useContext } from 'react';
import { DefaultIcon } from '../../common';
import { StyledRow, StyledIcon } from '../elements';
import { getChildByType } from '../../../../util';
import { Description } from './Description';
import { Term } from './Term';
export const RowContext = /*#__PURE__*/React.createContext({});
export const Row = ({
  children,
  hasDivider,
  iconSrc,
  ...rest
}) => {
  const {
    isCard,
    hasDividers,
    hasIcons,
    isSpacingCompact
  } = useContext(RowContext);
  const SingleTerm = getChildByType(children, Term);
  const SingleDescription = getChildByType(children, Description);
  return /*#__PURE__*/React.createElement(StyledRow, _extends({
    isCard: isCard,
    hasDivider: hasDivider,
    hasDividers: hasDividers,
    hasIcons: hasIcons,
    isSpacingCompact: isSpacingCompact
  }, rest), hasIcons && /*#__PURE__*/React.createElement(StyledIcon, null, /*#__PURE__*/React.createElement(DefaultIcon, {
    src: iconSrc
  })), SingleTerm, SingleDescription);
};